/// <reference path="./types.d.ts" />node_modules\
import { AiMotuEngine } from './dist/ai-motu-sdk.es.js'
// @ts-ignore
// import { AiMotuEngine } from 'ai-motu-engine'
// import 'ai-motu-engine/style/index.css'
import '@/sdk/dist/dist-sdk.css'

import { saveTemplate, uploadfile, loadTemplate, onDpiChange, setfontList, uploadFont, AIsearchimg, downloadFile, AIcutout, moveResourceMasonryTo, downloadPsd, opentagdialog, changeCanvas } from '../common/design'
import material from '../components/leftPanel/material/material.vue'
import image from '../components/leftPanel/image/image.vue'
import template from '../components/leftPanel/template/template.vue'
import text from '../components/text.vue'
import user from '../components/leftPanel/user/user.vue'
import team from '../components/leftPanel/team/team.vue'
import tag from '../components/leftPanel/tag/tag.vue'
import login from '../components/topPanel/login/login.vue'
import topteam from '../components/topPanel/team/team.vue'
import home from '../components/topPanel/home/home.vue'
import templateName from '../components/topPanel/templateName/templateName.vue'



import createDesing from '../components/fileActions/createDesign/createDesing.vue'
import fileImport from '../components/fileActions/fileImport/fileImport.vue'
import JSONImport from '../components/fileActions/jsonimport/JSONImport.vue'
import saveAs from '../components/fileActions/saveAs/saveAs.vue'

import resourceLibrary from '../components/resourceLibrary/resourceLibrary.vue'
import imageSearch from '../components/leftPanel/imageSearch/imageSearch.vue'

import { useMiscStore } from '@/stores/misc'
import { useUserStore } from '@/stores/user'

/**
 * 初始化 SDK 实例
 * @param container 容器选择器
 * @returns SDK 实例
 */
export const initSdk = async (container: string = '#page', islogin: boolean = false) => {
  const miscStore = useMiscStore()
  const userStore = useUserStore()
  let teamInfo = userStore.currentTeamInfo || {}
  let pageType = localStorage.getItem('pageType') || ''
  return new AiMotuEngine({

    container,
    onDpiChange: onDpiChange,
    hostMethods: {
      loadTemplate: loadTemplate,
      uploadfile: uploadfile,
      saveTemplate: saveTemplate,
      downloadFile: downloadFile,
      changeCanvas: changeCanvas,
    },
    dynamicDpi: false,
    fontconfig: {
      showFontUplaod: false,
      fontUpload: async (uploadList: any) => {
        await uploadFont(uploadList)
      },
    },
    // && (userStore.currentTeamInfo()?.corp_code)
    showDownloadFile: islogin,
    leftPanel: [
      ...(pageType !== 'addtemplate' ? [{ name: '模板', icon: 'moban', component: template, type: 'template', showBar: true }] : []),
      ...(pageType !== 'addtemplate' ? [{ name: '素材', icon: 'sucai', component: material, type: 'material', showBar: true }] : []),
      ...(pageType !== 'addtemplate' ? [{ name: '图片', icon: 'tupian', component: image, type: 'image', showBar: true }] : []),
      { name: '打标', icon: 'https://shanyin-design.oss-cn-hangzhou.aliyuncs.com/shanyin-design/image/user/1_1763617516163_定位_2.png', component: tag },
      ...(islogin && pageType !== 'addtemplate' ? [{ name: '我的', icon: 'wode', component: user, type: 'user', showBar: true }] : []),
      ...(islogin && (teamInfo?.corp_code) && pageType !== 'addtemplate' ? [{ name: '团队', icon: 'https://shanyin-design.oss-cn-hangzhou.aliyuncs.com/shanyin-design/image/user/7_1763971495000_7575a4b4-7e59-470f-912e-1c6ce8f08ff3.png', component: team, type: 'team', showBar: true }] : []),
      { name: '图片搜索', icon: 'https://shanyin-design.oss-cn-hangzhou.aliyuncs.com/shanyin-design/image/user/4_1763694135316_扫码.png', component: imageSearch, type: 'imageSearch', showBar: false },
    ],
    headerPanel: [
      { position: 'RightFront', component: topteam },
      { position: 'RightFront', component: login },
      { position: 'centerRear', component: templateName },
      ...(islogin ? [{ position: 'LeftFront', component: home },] : []),

    ],
    canvasContextMenu: [
      { position: 13, element: true, item: { text: '打标', handler: () => { opentagdialog() } } },
      // { position: 0, element: true, item: { text: '移动到...', handler: () => moveResourceMasonryTo() } },
    ],
    fileActions: [
      { component: templateName },
      { component: createDesing },
      { component: saveAs },
      { component: fileImport },
      { component: JSONImport },

    ],
    toolbarActions: [
      {
        position: 3, element: {
          tooltip: 'AI搜图',
          icon: 'https://shanyin-design.oss-cn-hangzhou.aliyuncs.com/shanyin-design/image/user/4_1763694135316_扫码.png',
          iconClassName: 'text-18px color-#333',
          btnClass: 'h-[32px] w-[32px] rounded-3px mr-4px',
          type: 'Image',
          onClick: AIsearchimg
        }
      },
      ...(
        miscStore.getAIToolconfig(1)
          ? [{
            position: 4, element: {
              tooltip: 'AI抠图',
              icon: 'https://shanyin-design.oss-cn-hangzhou.aliyuncs.com/shanyin-design/image/user/44_1765245537000_5c4f7448-9ff9-4754-a5e6-5905a6759d4a.png',
              iconClassName: 'text-18px color-#333',
              btnClass: 'h-[32px] w-[32px] rounded-3px mr-4px',
              type: 'Image',
              onClick: AIcutout
            }
          }]
          : []
      )
    ],
    // 
    leftBottomPanel: islogin && (teamInfo?.corp_code) ? [
      //@ts-ignore

      { name: '成员', icon: 'https://shanyin-design.oss-cn-hangzhou.aliyuncs.com/shanyin-design/image/user/44_1765185769000_db52a892-4de5-4b2c-868e-81223900c2fd.png', clickFun: () => { Auth.header.showInvitePopup() } },
      { name: '管理', icon: 'https://shanyin-design.oss-cn-hangzhou.aliyuncs.com/shanyin-design/image/user/44_1765185463000_69475065-5459-4ded-a080-2d2e14bee086.png', clickFun: () => { window.open('https://passport.manocode.cn/team-info/' + miscStore.getClientID(), '_blank') } }
    ] : [],
    resourceLibrary: {
      component: resourceLibrary,
    },
    downloadType: [
      {
        id: 100,
        type: 'psd',
        name: 'psd',
        desc: '可以显著减小文件大小，加快网页加载速度',
        hasSize: false,
        options: [],
        checkbox: false,
        checklabel: '',
        downloadfun: downloadPsd
      }
    ]
  })
}


export interface SdkConfig {
  container?: string
  onDpiChange?: (dpi: number) => void
  hostMethods?: {
    loadTemplate?: Function
    uploadfile?: Function
    saveTemplate?: Function
  }
  fontconfig?: {
    showFontUplaod?: boolean
    fontUpload?: Function
    fontList?: Array<any>
  }
  dynamicDpi?: boolean
  showDownloadFile?: boolean
  leftPanel?: Array<any>,
  canvasContextMenu?: Array<any>,
}
// getDynamicDpi: true,
/**
 * 使用自定义配置初始化 SDK
 * @param config SDK 配置选项
 * @returns SDK 实例
 */
export const initSdkWithConfig = (config: SdkConfig) => {
  const defaultConfig: SdkConfig = {
    container: '#page',
    onDpiChange: onDpiChange,
    hostMethods: {
      loadTemplate: loadTemplate,
      uploadfile: uploadfile,
      saveTemplate: saveTemplate,
    },
    dynamicDpi: true,
    showDownloadFile: true,
    leftPanel: [
      { name: '素材', icon: 'sucai', component: material },
      { name: '图片', icon: 'tupian', component: image },
      { name: '模板', icon: 'moban', component: template },
      { name: '文字', icon: 'tupianbianjiqi_wenzi', component: text },
      { name: '我的', icon: 'wode', component: user },

    ],
  }

  // 合并配置
  const mergedConfig = { ...defaultConfig, ...config }

  return new AiMotuEngine(mergedConfig)
}

// 导出字体列表供外部使用
